import type { Problem } from '@/api/sirta/problems';
import type { Maybe } from '@/types/helpers.types';

/**
 * Un problème non pas au niveau de notre application, mais au niveau HTTP. Chaque appel doit gérer ces erreurs.
 */
export type HttpProblem = Problem & {
  reason: ErrorCode;
};

export type APIResponse<TData, TProblem extends Problem = Problem> =
  | {
    data: TData;
    problem: undefined;
  }
  | {
    data: null;
    // le BFF retourne toujours les potentielles erreurs HTTP comme des objets "problem", sauf indication contraire
    problem: Maybe<TProblem | HttpProblem>;
  };

export type ErrorDetails<TErr> = Partial<Record<keyof TErr, string[]>>;

/**
 * Erreurs HTTP documentées/supportées par l'API en cas de problème.
 * L'ajout d'une nouvelle erreur implique l'ajout de clés i18n dans le dictionnaire
 * afin d'afficher le bon message à l'utilisateur, le cas échéant.
 */
export enum ErrorCode {
  HTTP_400 = 'http.400',
  HTTP_401 = 'http.401',
  HTTP_403 = 'http.403',
  HTTP_404 = 'http.404',
  HTTP_422 = 'http.422',
  HTTP_500 = 'http.500',
  HTTP_503 = 'http.503', // seulement pour les données temps réel non disponibles
  HTTP_GENERIC = HTTP_500,
}
